var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.submitLoading),expression:"submitLoading"}],staticClass:"full-w full-h"})
}
var staticRenderFns = []

export { render, staticRenderFns }